import { render, staticRenderFns } from "./LmProfilePicture.vue?vue&type=template&id=4c09cff0&scoped=true&"
import script from "./LmProfilePicture.vue?vue&type=script&lang=js&"
export * from "./LmProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./LmProfilePicture.vue?vue&type=style&index=0&id=4c09cff0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09cff0",
  null
  
)

export default component.exports